import React from "react";
import PropTypes from "prop-types";
import { Button } from '@/components/ui/button'

/**
 * NotificationPermission Component
 * Note: Core Snackbar functionality has been migrated to custom implementation
 */
function NotificationPermission({ 
  open, 
  handleClose, 
  openStatus = false, 
  message = "", 
  actionMessage = "", 
  actionMessage2, 
  href, 
  children, 
  className = "", 
  onActionClick = () => {}, 
  onActionClick2,
  onNotificationClose = () => {},
  classes = {},
  ...rest 
}) {

    return (
        <div className="w-full">
            {openStatus && (
                <div className="fixed top-0 left-0 right-0 z-50 bg-gradient-to-r from-primary to-primary/80 p-4 shadow-lg">
                    <div className="flex items-center justify-between max-w-4xl mx-auto">
                        <div className="text-white">{message}</div>
                        <div className="flex gap-2">
                            <Button className="enableNotification" color="secondary" size="small" variant="outlined" onClick={onActionClick} title={actionMessage}></Button>
                            <Button className="enableNotification" color="secondary" size="small" variant="outlined" onClick={onActionClick2} title={actionMessage2}></Button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

// prop types
NotificationPermission.propTypes = {
    children: PropTypes.any,
    openStatus: PropTypes.bool,
    onActionClick: PropTypes.func,
    onNotificationClose: PropTypes.func,
    classes: PropTypes.object,
    className: PropTypes.string,
    message: PropTypes.string,
    actionMessage: PropTypes.string,
};

export default NotificationPermission;
